// Each palette is { name, stops: [vec3, vec3, vec3] } where stops are 3 RGB
// triplets in 0..1 floats. Hand-tuned so each preset has a clear identity
// distinct from the audio-driven hue shift the shader applies on top.
export const PALETTES = [
  { name: 'sunset',     stops: [[0.95, 0.40, 0.20], [0.20, 0.50, 0.95], [0.60, 0.30, 0.80]] }, // original
  { name: 'aurora',     stops: [[0.10, 0.80, 0.50], [0.30, 0.40, 0.95], [0.85, 0.20, 0.70]] },
  { name: 'lava',       stops: [[1.00, 0.20, 0.05], [1.00, 0.65, 0.10], [0.30, 0.05, 0.00]] },
  { name: 'ice',        stops: [[0.70, 0.92, 1.00], [0.30, 0.55, 0.95], [0.05, 0.10, 0.30]] },
  { name: 'neon',       stops: [[1.00, 0.10, 0.85], [0.10, 1.00, 0.60], [0.20, 0.30, 1.00]] },
  { name: 'monochrome', stops: [[0.95, 0.95, 0.95], [0.50, 0.50, 0.55], [0.05, 0.05, 0.10]] },
  { name: 'desert',     stops: [[0.95, 0.75, 0.45], [0.85, 0.45, 0.30], [0.30, 0.15, 0.10]] },
  { name: 'forest',     stops: [[0.35, 0.75, 0.40], [0.15, 0.45, 0.30], [0.05, 0.20, 0.10]] },
  { name: 'cyberpunk',  stops: [[0.95, 0.10, 0.55], [0.10, 0.85, 0.95], [0.30, 0.05, 0.60]] },
  { name: 'oceanic',    stops: [[0.05, 0.40, 0.60], [0.10, 0.75, 0.85], [0.95, 0.95, 0.75]] },
  { name: 'sakura',     stops: [[1.00, 0.75, 0.85], [0.95, 0.40, 0.65], [0.50, 0.15, 0.45]] },
  { name: 'gold-rush',  stops: [[1.00, 0.85, 0.30], [0.95, 0.55, 0.10], [0.30, 0.10, 0.05]] },
  { name: 'electric',   stops: [[0.30, 1.00, 0.95], [0.95, 0.10, 0.95], [0.95, 0.95, 0.10]] },
  { name: 'midnight',   stops: [[0.30, 0.10, 0.55], [0.55, 0.20, 0.95], [0.05, 0.05, 0.20]] },
];

export function paletteNameFromId(id) {
  const n = ((Number(id) || 0) % PALETTES.length + PALETTES.length) % PALETTES.length;
  return PALETTES[n].name;
}
